import {Box, Divider, ListItemButton, ListItemText, Stack, Toolbar, Typography} from '@mui/material'
import {lazy, memo} from 'react'
import {NavLink, useMatch} from 'react-router'
import {ErrorBoundary} from '../../../../components/ErrorBoundary'
import {getLangUrl} from '../../../../hooks/useSpotNavigate'
import {LocaleSelector} from '../LocaleSelector'
import {MenuGlobal} from './MenuGlobal'
import {MenuSwitch} from './MenuSwitch'

const MenuSpot = lazy(async () => ({default: (await import('./MenuSpot')).MenuSpot}))

const MenuSpotToggle = memo(() => {
  const match = !!useMatch('/:lang/spot/:spotSlug/*')
  if (!match) {
    return null
  }

  return <MenuSpot/>
})

export const Menu = memo(() => {
  return <>
    <Toolbar/>
    <ErrorBoundary mode="log">
      <Stack sx={{flexGrow: 1, overflow: 'hidden'}}>
        <Box sx={{
          flexGrow: 1,
          overflow: 'auto',

          '& > hr:first-of-type:not(style):not(:first-of-type ~ *), & > style:first-of-type + hr': { // hack for `:first-child`
            display: 'none',
          },
        }}>
          <MenuGlobal/>

          <MenuSpotToggle/>

          <MenuSwitch/>
        </Box>

        <Stack direction="row" sx={{marginTop: 'auto'}}>
          <ListItemButton dense component={NavLink} to={getLangUrl('/')}>
            <ListItemText primary={<Typography noWrap variant="subtitle2">VerticalTopo.com</Typography>}/>
          </ListItemButton>

          <Divider orientation="vertical" variant="middle" flexItem/>
          <LocaleSelector/>
        </Stack>
      </Stack>
    </ErrorBoundary>
  </>
})
